export enum LandSystem {
    Jeffersonian = 1,
    Eastern,
    WestTexas,
    EastTexas,
    RightOfWay = 1001
}


// WEBPACK FOOTER //
// ./src/models/LandSystem.ts